import type { SeverityDto } from '@internal/scorecards-common';
import { useEffect, useState } from 'react';

import { scorecardsApiRef } from '../api/ScorecardsApi';
import { useApi } from '@backstage/core-plugin-api';

export function useSeverities(): {
  severities: SeverityDto[];
  loading: boolean;
} {
  const api = useApi(scorecardsApiRef);
  const [severities, setSeverities] = useState<SeverityDto[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api
      .getSeverities()
      .then(result => {
        if (!cancelled) setSeverities(result);
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [api]);

  return { severities, loading };
}
